export const RENT_ANALYZER_REQUIRED_FIELDS_TOOLTIP = 'Please add Rent, Bed, Bath and Sq Ft to use Rent Analyzer.';

export const RENT_ANALYZER_LABEL = 'Rent Analyzer';

export const parseRentAnalyzerTierRequirement = (value: unknown): number | null => {
  if (typeof value === 'boolean' || value === null || value === undefined || value === '') {
    return null;
  }

  const parsedValue = Number(value);

  return Number.isFinite(parsedValue) ? parsedValue : null;
};

export const isRentAnalyzerTierEligible = (
  buildingTier: number | null | undefined,
  requiredTier: number | null | undefined,
): boolean => {
  if (buildingTier === null || buildingTier === undefined || requiredTier === null || requiredTier === undefined) {
    return false;
  }

  return buildingTier >= requiredTier;
};

export const parseRentAnalyzerNumeric = (value: string | number | null | undefined): number | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const normalizedValue = String(value).replace(/[,$\s]/g, '');
  const parsedValue = Number(normalizedValue);

  return Number.isFinite(parsedValue) ? parsedValue : null;
};

export const isRentAnalyzerInputMissing = (
  values: Array<string | number | null | undefined>,
): boolean => values.some((value) => parseRentAnalyzerNumeric(value) === null);

export const getRentAnalyzerTooltipText = (isInputMissing: boolean): string => (isInputMissing ? RENT_ANALYZER_REQUIRED_FIELDS_TOOLTIP : RENT_ANALYZER_LABEL);
